import angular from 'angular';

export const accountViews = angular.module(
  'portainer.app.react.views.account',
  []
).name;
